import './heading-block.scss';

export default () => {

};
